/* eslint-disable */

import Component from 'gia/Component'

export default class CoverImage extends Component {
  constructor(element) {
    super(element)
  }

  sizing() {
    let imgratio = this.element.querySelector('.img--responsive').style
      .paddingBottom
    imgratio = imgratio.substring(0, imgratio.length - 1)
    function winratio(e) {
      return (e.offsetHeight / e.offsetWidth) * 100
    }

    const el = this.element

    let container = winratio(el)

    function classes(img, container) {
      if (img > container) {
        el.classList.add('taller')
        el.classList.remove('wider')
      } else {
        el.classList.add('wider')
        el.classList.remove('taller')
      }
    }
    classes(imgratio, winratio(el))

    window.addEventListener('load', function() {
      classes(imgratio, winratio(el))
    })

    window.addEventListener('resize', function() {
      classes(imgratio, winratio(el))
    })
  }

  mount() {
    this.sizing()
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/CoverImage.js